import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LanguageEnum } from '@project-types/enums';
import { getDay } from 'date-fns';
import { cs, enUS } from 'date-fns/locale';
import { resources } from '@translations/imports';



export default function loadTranslations() {
	i18next.use(initReactI18next).init({
		lng: LanguageEnum.cz,
		fallbackLng: LanguageEnum.en,
		interpolation: {
			escapeValue: false, // React already escapes values
		},
		ns: [ 'global' ],
		resources: resources,
	});
};


export function setLanguage(lng: LanguageEnum) {
	i18next.changeLanguage(lng);
};


export function toggleLanguage() {
	const lng = i18next.language;
	if (lng === LanguageEnum.en) i18next.changeLanguage(LanguageEnum.cz);
	if (lng === LanguageEnum.cz) i18next.changeLanguage(LanguageEnum.en);
};


export function getLocaleObject() {
	const lng = i18next.language;
	if (lng === LanguageEnum.cz) return cs;
	return enUS;
};

export function getDateFormat(settings?: { withTime: boolean }) {
	const lng = i18next.language;
	if (lng === LanguageEnum.cz && settings && settings.withTime === true) return 'dd.MM.yyyy - HH:mm';
	if (lng === LanguageEnum.cz) return 'dd.MM.yyyy';
	if (settings && settings.withTime === true) return 'MM/dd/yyyy - HH:mm'
	return 'MM/dd/yyyy';
};

export function getDaysEnum() {
	const locale = getLocaleObject();
	
	if (!locale.localize) return ({
		sunday: 'Su',
		monday: 'Mo',
		tuesday: 'Tu',
		wednesday: 'We',
		thursday: 'Th',
		friday: 'Fr',
		saturday: 'Sa'
	});

	return ({
		sunday: locale.localize.day(0, { width: 'short' }) as string,
		monday: locale.localize.day(1, { width: 'short' }) as string,
		tuesday: locale.localize.day(2, { width: 'short' }) as string,
		wednesday: locale.localize.day(3, { width: 'short' }) as string,
		thursday: locale.localize.day(4, { width: 'short' }) as string,
		friday: locale.localize.day(5, { width: 'short' }) as string,
		saturday: locale.localize.day(6, { width: 'short' }) as string
	});
}

export function getDayFromDate(date: Date) {
	const locale = getLocaleObject();
	const day = getDay(date);

	if (locale.localize && (day == 0
		|| day == 1
		|| day == 2
		|| day == 3
		|| day == 4
		|| day == 5
		|| day == 6)) {
		return locale.localize.day(day, { width: 'short' }) as string;
	}

	switch (day) {
		case 0: return 'Su';
		case 1: return 'Mo';
		case 2: return 'Tu';
		case 3: return 'We';
		case 4: return 'Th';
		case 5: return 'Fr';
		case 6: return 'Sa';
		default: return '-';
	}
}

export function getDayName(day: number) {
	if (day === null || day === undefined || typeof day !== 'number') return '-';

	const locale = getLocaleObject();

	if (locale.localize && (day == 0
		|| day == 1
		|| day == 2
		|| day == 3
		|| day == 4
		|| day == 5
		|| day == 6)) {
		return locale.localize.day(day, { width: 'wide' }) as string;
	}

	switch (day) {
		case 0: return 'Sunday';
		case 1: return 'Monday';
		case 2: return 'Tuesday';
		case 3: return 'Wednesday';
		case 4: return 'Thursday';
		case 5: return 'Friday';
		case 6: return 'Saturday';
		default: return '-';
	}
}


export function getLocaleNumberSeparator(stringNumber: string) {
	const lng = i18next.language;
	if (lng === LanguageEnum.cz) return stringNumber.replace('.', ',');
	return stringNumber;
}